import { Store } from "pullstate";

export const UserStore = new Store({
  user: null,
});

export const UserLang = new Store({
  lan: null,
});

export const UserEpg = new Store({
  array: null,
});
